export const TrackingEventNames = {
  DEVICES_SHELL: 'devices_shell',
  DEVICES_OVERVIEW: 'device_info_page'
};
